// extracted by mini-css-extract-plugin
module.exports = {"lazyLoader":"Zf-z","hidden":"_f-z","preventTransition":"ag-z","divBgImg":"bg-z","loaded":"cg-z"};